import { method as toBluebird } from "bluebird";
import { SupportsAppContainer } from "winapi-bindings";
import { testSupported } from "./tester";
import { install } from "./installer";
import { settingsReducer } from "./reducers/sandbox";
import Sandbox from "./views/Sandbox";
/**
 * Extension initialization
 */
const main = (context) => {
    context.registerReducer(["settings", "mods"], settingsReducer);
    const osSupportsAppContainer = SupportsAppContainer?.() ?? false;
    context.registerSettings("Workarounds", Sandbox, () => ({
        osSupportsAppContainer,
    }));
    context.registerInstaller(
    /*id:*/ `fomod`, 
    /*priority:*/ 20, 
    /*testSupported:*/ toBluebird(async (files, gameId, _archivePath, details) => {
        return await testSupported(context.api, files, gameId, details);
    }), 
    /*install:*/ toBluebird(async (files, destinationPath, gameId, _progressDelegate, choices, unattended, archivePath, details) => {
        return await install(context.api, files, destinationPath, gameId, choices, unattended, archivePath, details);
    }));
    return true;
};
export default main;
